import { PaginationResponseType } from '@/common/types/ApiResponseTypes.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';

type NameType =
  | 'car'
  | 'motorcycle'
  | 'trailer'
  | 'auto'
  | 'trolley'
  | 'agricultural';
type ResponseType = Promise<
  PaginationResponseType<{ id: string; name: NameType; fa_name: string }[]>
>;
export const vehicleTypeRequest = ({
  vehicleTypeName,
}: {
  vehicleTypeName: string | null;
}): ResponseType =>
  fetchApi({
    method: 'GET',
    url: 'selection_item/vehicle_type/list/',
    params: { name: vehicleTypeName },
  });
